<template>
    <div class="pcPage">
        <div class="loginCon">
            <div class="nologin" v-if="!getUserInfo.isLogin">
                <span class="btn" @click="loginFun">注册</span><span>|</span><span class="btn" @click="loginFun">登录</span>
            </div>
            <div class="islogin" v-if="getUserInfo.isLogin">
                <span class="btn" @click="loginOut">退出</span>
                <span>|</span>
                <span class="award" @click="routerTo('pcpage/awardinfo')" v-if="getUserInfo.have_award" >获奖信息</span>
                <span v-if="getUserInfo.have_award">|</span>
                <span>{{ getUserInfo.username }}</span>
            </div>
        </div>
        <div class="header">
            <img src="../img/Vcard/cbanner.png" alt="" class="banner">
            <!-- <img src="../img/celc.png" alt="" class="logo"> -->
        </div>

        <div class="contentBox ">
            <div class="toHome">
                <router-link to="/pcpage/home">
                    <div>
                        < 首页</div>
                </router-link>
            </div>

            <div class="content link topBox">
                <div class="title">
                    大赛评委
                </div>
                <div class="topBox">
                    <div class="box">
                        <div class="name">廖媛</div>
                        <div class="text">中国日报网国际传播部创意主管</div>
                        <div class="text">中国日报网旗下留学中国海外社交媒体矩阵负责人</div>
                    </div>
                    <div class="box">
                        <div class="name">付晓光</div>
                        <div class="text">中国传媒大学电视学院教授</div>
                        <div class="text">博士生导师</div>
                    </div>
                </div>
            </div>

            <div class="content link">
                <div class="title title2">
                    VLOG 奖品设置
                </div>
                <div class="introduce">
                    <div class="text">
                        请各位参与“闪亮的青春”志愿者短视频与图片故事征集活动的老师登陆您的账号，凡是作品通过展示的老师均会获得电子证书，请您自行下载打印，获得相关奖项的老师，请您认真填写相关信息，会有工作人员与您进行联络！
                    </div>
                    <div class="text">如有咨询问题，请通过邮箱：zhengji@chineseplus.net；QQ号码：2151697624 与工作人员联络。</div>
                </div>
                <div class="cardBoxList">
                    <div class="cardBox">
                        <img class="pic" src="../img/Vcard/c1000.jpg" alt="">
                        <div class="cardTitle">一等奖、网络人气奖</div>
                        <div class="text">当当V卡1000元</div>
                    </div>
                    <div class="cardBox">
                        <img class="pic" src="../img/Vcard/c500.jpg" alt="">
                        <div class="cardTitle">二等奖</div>
                        <div class="text">当当V卡500元</div>
                    </div>
                    <div class="cardBox">
                        <img class="pic" src="../img/Vcard/c200.jpg" alt="">
                        <div class="cardTitle">三等奖</div>
                        <div class="text">当当V卡200元</div>
                    </div>
                    <div class="cardBox">
                        <img class="pic" src="../img/Vcard/c100.jpg" alt="">
                        <div class="cardTitle">优秀奖</div>
                        <div class="text">当当V卡100元</div>
                    </div>

                </div>

            </div>

        </div>

        <div class="copyRight">
            <div>
                <img src="../img/celc_logo.png" alt="" class="logo">
            </div>
            <div class="footerMessage">
                主办单位：中外语言交流合作中心
            </div>
            <div class="footerMessage">
                <span>
                    地址：北京市西城区德胜门外大街<span class="num">129</span>号 邮编: <span class="num">100088</span></span>
            </div>
            <div>
                <div class="footerMessage">
                    版权所有： 中外语言交流合作中心 <a href="http://beian.miit.gov.cn">京ICP 备 <span class="num">08002516-8</span></a></div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'pcpage',
    data: function () {
        return {
            tip: true
        }
    },
    computed: {
        ...mapGetters(['getUserInfo']),
    },
    mounted() {
        this.checkLogin()
    },
    methods: {
        ...mapActions(['setUserInfoAction']),
        // 检查登录状态
        checkLogin() {
            this.$utils.get('/user/checkLogin', { withinfo: 1 }).then(res => {
                if (res.code === 1000) {
                    console.log(this)
                    this.setUserInfoAction({
                        isLogin: true,
                        username: res.data.username,
                        volunteer_info: res.data.volunteer_info,
                        have_award: res.data.have_award,
                        express: res.data.express
                    })
                    if (res.data.volunteer_info == 0) {
                        if (this.$route.path.indexOf('submitlist')) {
                            //   this.$router.push('/pcpage/userinfo')
                        }
                    }
                    if (res.have_award == 1 && res.data.express == 0){
                        console.log(res)
                        //报名 获奖 没填写
                        this.$message({
                            message: '恭喜你获奖了，请填写你的获奖信息！',
                            type: 'warning'
                        });
                    }
                } else {
                    this.setUserInfoAction({
                        isLogin: false,
                        username: '',
                        volunteer_info: 0
                    })
                    // this.loginFun()
                }
            })
        },
        routerTo(url) {
            this.$router.push({
                path: url,
            })
        },
        // 登录
        loginFun() {
            const currentUrl = window.location.href
            window.location.href = 'https://collection2021.chineseplus.net/user/login?callback=' + encodeURIComponent(currentUrl)
        },
        // 退出登录
        loginOut() {
            this.$utils.get('/user/logout', {}).then(res => {
                if (res) {
                    window.location.reload()
                }
            })
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.pcPage {
    width: 100%;
    min-height: 100%;
    min-width: 1200px;
    position: relative;
    font-family: 'Microsoft YaHei';
    font-size: 0;
    background-image: url(../img/bg.png);
    background-size: cover;
    background-repeat: repeat;

    .loginCon {
        font-size: 18px;
        height: 50px;
        line-height: 50px;
        background-color: #fff;

        .nologin,
        .islogin {
            width: 1200px;
            margin: auto;

            span {
                float: right;
                margin-left: 15px;
            }

            .btn {
                cursor: pointer;
            }
        }

        .award {
            color: #fb3737;
            cursor: pointer;
        }

    }

    .header {
        width: 100%;
        position: relative;

        .banner {
            width: 100%;
        }

        .logo {
            position: absolute;
            bottom: 4%;
            left: 0;
            right: 0;
            margin: 0 auto;
        }
    }

    .contentBox {
        width: 1200px;
        margin: auto;

        .toHome {
            position: relative;
            height: 100px;
            width: 100px;

            div {
                width: 100px;
                height: 100px;
                line-height: 100px;
                font-size: 18px;
                color: #0b2ab0;
            }
        }

        .content {
            width: 1200px;
            // margin: auto;
            background-color: #fbf8fe;
            padding: 0 37px 70px;
            text-align: center;
            margin-top: 40px;
            box-sizing: border-box;

            .title {
                position: relative;
                top: -35px;
                width: 405px;
                height: 70px;
                line-height: 65px;
                margin: auto;
                background-image: linear-gradient(0deg,
                        #746bef 0%,
                        #728bf9 100%);
                border-radius: 35px;
                text-align: center;
                font-size: 50px;
                color: #fff;
                font-weight: bold;

                &:before {
                    position: absolute;
                    left: -60px;
                    top: 15px;
                    content: '';
                    display: inline-block;
                    width: 60px;
                    height: 60px;
                    background-image: url(../img/left.png);
                    background-repeat: no-repeat;
                }

                &:after {
                    position: absolute;
                    right: -80px;
                    top: 15px;
                    content: '';
                    display: inline-block;
                    width: 60px;
                    height: 60px;
                    background-image: url(../img/right.png);
                    background-repeat: no-repeat;
                }
            }

            .title2 {
                width: 500px;
                margin-top: 100px;
            }

            .topBox {
                display: flex;
                flex-direction: row;

                .box {
                    width: 100%;

                    .name {
                        
                        font-size: 32px;
                        margin-top: 20px;
                        margin-bottom: 20px;
                        font-weight: 700;
                        color: #0b2ab0
                    }

                    .text {
                        font-size: 18px;
                        line-height: 24px;
                        color: #000;
                    }
                }
            }

            .introduce {
                width: 100%;
                text-align: initial;

                .text {
                    font-size: 17px;
                    line-height: 25px;
                    color: #000;
                }
            }

            .cardBoxList {
                width: 100%;
                margin-top: 40px;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: start;

                .cardBox {
                    width: 50%;
                    display: flex;
                    flex-direction: column;
                    margin-bottom: 37px;

                    .pic {
                        width: 400px;
                        height: 400px;
                        margin: auto;
                        background-color: #fff;
                        // border-radius: 15px;
                    }

                    .cardTitle{
                        font-size: 24px;
                        margin-top: 20px;
                        color: #0b2ab0;
                        font-weight: 800;
                    }

                    .text {
                        margin-top: 15px;
                        font-size: 20px;
                        color: #000000;
                        font-weight: 700;
                    }

                }

            }

        }






    }




    .copyRight {
        // position: absolute;
        bottom: 0px;
        left: 0;
        text-align: center;
        font-size: 20px;
        color: #a38fe9;
        margin-top: 30px;
        padding-bottom: 32px;
        right: 0;
        margin: 30px auto 0;
        background-color: #031e5d;
        padding: 33px 0;
        color: hsla(0, 0%, 100%, .6);
        font-size: 14px;

        .logo {
            width: 60px;
            margin: 0 auto 20px;
        }

        .footerMessage {
            margin-bottom: 10px;

            a {
                color: #c9bc9c;
            }
        }
    }

    .tip {
        position: fixed;
        left: 20px;
        z-index: 5;
        top: 0;

        .uploadTip {
            position: absolute;
            bottom: 30px;
            font-size: 24px;
            left: 0;
            color: #fff;
            border-radius: 30px;
            text-align: center;
            right: 0;
            margin: auto;
            background-color: rgb(75, 77, 240);
            box-shadow: 0px 0px 16px 0px rgba(116, 116, 116, 0.5);
            position: absolute;
            width: 267px;
            height: 48px;
            line-height: 48px;
            cursor: pointer;
        }

        .close {
            position: absolute;
            bottom: -40px;
            left: 0;
            right: 0;
            margin: auto;
            cursor: pointer;
        }
    }

    .review_con {
        position: fixed;
        right: 20px;
        top: 45px;
        z-index: 5;
        cursor: pointer;
    }
}</style>
